export default {hello:'Hello',invoiceAddress:{lastName:'@:personalData.lastName'}};